export default __webpack_public_path__ + "static/media/new-promo-offers-icon.fba0bcdc.svg";